__turbopack_context__.v({
  "appleStyle": "SocialLoginButton-module__rW9dlq__appleStyle",
  "enterFlow2026": "SocialLoginButton-module__rW9dlq__enterFlow2026",
  "facebookStyle": "SocialLoginButton-module__rW9dlq__facebookStyle",
  "googleStyle": "SocialLoginButton-module__rW9dlq__googleStyle",
  "loading": "SocialLoginButton-module__rW9dlq__loading",
  "loadingIndicator": "SocialLoginButton-module__rW9dlq__loadingIndicator",
  "logo": "SocialLoginButton-module__rW9dlq__logo",
  "socialLoginButton": "SocialLoginButton-module__rW9dlq__socialLoginButton",
  "socialLoginButtonInner": "SocialLoginButton-module__rW9dlq__socialLoginButtonInner",
  "socialLoginButtonText": "SocialLoginButton-module__rW9dlq__socialLoginButtonText",
});
